import { MappingProfile} from '@automapper/core';
import { mapOperationalDataModel } from '../operational-data-model/operational-data-model-mapping';

export const opDataProfile: MappingProfile = (mapper) => {
    mapOperationalDataModel(mapper);
};
